module.exports = __webpack_public_path__ + "img/economia_ouro.f588de9c.png";